import React, { useState } from 'react';

const TimeLineElement = ({ title, isActive, handleClick }) => {
	return (
		<span
			onClick={handleClick}
			className={`timeline-title ${isActive ? 'active' : ''}`}
		>
			{title}
		</span>
	);
};

const CustomTimeline = ({ timelineYear, selectedYear, onChange }) => {
	console.log({ timelineYear, selectedYear });
	return (
		<>
			<div className='custom-timeline-parent'>
				<div className='custom-timeline-wrapper'>
					<div className='custom-timeline'></div>
					{timelineYear.map((year, idx) => (
						<TimeLineElement
							key={'timelineYear' + idx}
							title={year.title}
							isActive={year.title == selectedYear}
							handleClick={() => onChange(year)}
						/>
					))}
				</div>
			</div>
		</>
	);
};

export default CustomTimeline;
